import { ChevronLeft, ChevronRight } from "@/assets/icons";
import { ColorButton } from ".";

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void
}

export function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {


    return (
        <div className={`${totalPages === 0 ? 'hidden' : 'flex'} gap-3 justify-center items-center`}>
            <span>
                Página {currentPage} {' '}
                de {totalPages}
            </span>
            <ColorButton disabled={currentPage === 1}
                onClick={() => onPageChange(Math.max(1, currentPage - 1))}
            >
                <ChevronLeft />
            </ColorButton>
            <ColorButton disabled={currentPage === totalPages}
                onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
            >
                <ChevronRight />
            </ColorButton>
        </div>
    )
}